import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BilingualText } from '../components/BilingualText';
import { QrCode, Download, Share2, ArrowLeft, MapPin, Calendar, Clock, Truck, ShieldCheck } from 'lucide-react';
export function ShipmentDetails() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-1000">
      <header className="bg-white px-4 py-6 border-b border-slate-100 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-1001">
        <div className="flex items-center gap-4" data-id="element-1002">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-1003">
            <ArrowLeft size={24} data-id="element-1004" />
          </button>
          <BilingualText en="Shipment #ASN-98231" ar="شحنة رقم #ASN-98231" className="text-xl font-bold" data-id="element-1005" />
        </div>
        <div className="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs font-bold" data-id="element-1006">
          <span data-id="element-1007">Truck Arrived</span>
        </div>
      </header>

      <main className="p-4 space-y-6 max-w-2xl mx-auto" data-id="element-1008">
        {/* QR Code Section */}
        <div className="card p-8 flex flex-col items-center text-center space-y-4" data-id="element-1009">
          <div className="p-4 bg-white border-4 border-slate-50 rounded-2xl shadow-inner" data-id="element-1010">
            <QrCode size={180} className="text-[#2E3192]" data-id="element-1011" />
          </div>
          <div className="space-y-1" data-id="element-1012">
            <BilingualText en="Check-in QR Code" ar="رمز الاستجابة السريعة لتسجيل الدخول" className="text-xl" data-id="element-1013" />
            <BilingualText en="Show this code to the warehouse security upon arrival." ar="أظهر هذا الرمز لأمن المستودع عند الوصول." subtle data-id="element-1014" />
          </div>
          <div className="flex gap-3 w-full pt-4" data-id="element-1015">
            <button className="btn-secondary flex-1 py-3 text-sm" data-id="element-1016">
              <Download size={18} data-id="element-1017" />
              <BilingualText en="Download" ar="تحميل" data-id="element-1018" />
            </button>
            <button className="btn-secondary flex-1 py-3 text-sm" data-id="element-1019">
              <Share2 size={18} data-id="element-1020" />
              <BilingualText en="Share" ar="مشاركة" data-id="element-1021" />
            </button>
          </div>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 gap-4" data-id="element-1022">
          <InfoItem icon={Calendar} en="Appointment Date" ar="تاريخ الموعد" value="Wednesday, July 11, 2026" data-id="element-1023" />
          <InfoItem icon={Clock} en="Scheduled Time" ar="الوقت المحدد" value="09:30 AM" data-id="element-1024" />
          <InfoItem icon={MapPin} en="Warehouse" ar="المستودع" value="Riyadh Main Distribution Center (WH-01)" data-id="element-1025" />
          <InfoItem icon={Truck} en="Carrier Details" ar="تفاصيل الناقل" value="Aramex - Plate: LKR 4920" data-id="element-1026" />
        </div>

        {/* Shipment Content */}
        <div className="card p-4 space-y-4" data-id="element-1027">
          <BilingualText en="Shipment Content" ar="محتوى الشحنة" className="font-bold border-b border-slate-50 pb-2" data-id="element-1028" />
          <div className="flex justify-between items-center" data-id="element-1029">
            <div className="flex items-center gap-3" data-id="element-1030">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center text-slate-500" data-id="element-1031">
                <Package size={20} data-id="element-1032" />
              </div>
              <BilingualText en="Standard Cartons" ar="كراتين قياسية" data-id="element-1033" />
            </div>
            <span className="font-bold text-lg" data-id="element-1034">42</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1035">
            <div className="flex items-center gap-3" data-id="element-1036">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center text-slate-500" data-id="element-1037">
                <ShieldCheck size={20} data-id="element-1038" />
              </div>
              <BilingualText en="Euro Pallets" ar="طبالي يورو" data-id="element-1039" />
            </div>
            <span className="font-bold text-lg" data-id="element-1040">4</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3 pt-4" data-id="element-1041">
          <button className="btn-primary w-full py-4" data-id="element-1042">
            <BilingualText en="Start Check-in" ar="بدء تسجيل الدخول" className="text-white" data-id="element-1043" />
          </button>
          <button className="btn-secondary w-full py-4 border-red-100 text-red-600 hover:bg-red-50" data-id="element-1044">
            <BilingualText en="Cancel Appointment" ar="إلغاء الموعد" data-id="element-1045" />
          </button>
        </div>
      </main>
    </div>;
}
function InfoItem({
  icon: Icon,
  en,
  ar,
  value
}: {
  icon: any;
  en: string;
  ar: string;
  value: string;
}) {
  return <div className="card p-4 flex items-start gap-4" data-id="element-1046">
      <div className="p-2 bg-slate-100 rounded-lg text-[#2E3192]" data-id="element-1047">
        <Icon size={20} data-id="element-1048" />
      </div>
      <div className="flex-1" data-id="element-1049">
        <BilingualText en={en} ar={ar} subtle className="text-xs mb-1" data-id="element-1050" />
        <div className="font-bold text-slate-800" data-id="element-1051">{value}</div>
      </div>
    </div>;
}